import { render } from "./ShareDashboard.vue?vue&type=template&id=c1aa302a"
import script from "./ShareDashboard.vue?vue&type=script&lang=js"
export * from "./ShareDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__